import $ from 'jquery';

import Section from '../Section';
import { Breakpoints } from '../constants'

export default class TextAdverts extends Section {
    MOBILE_BREAKPOINT = Breakpoints.sm;

    constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);
        this.$element = $(element);
        this.$mobileSlider = this.$element.find('.mobile-homepage-text-adverts');
        this.mobileSliderFlexslider = null;
        const isMobile = this.theme.getBreakpoint().order <= this.MOBILE_BREAKPOINT.order;
        if (isMobile) {
            this.loadMobileSlider();
        }
        this.theme.loadIcons();
    }

    onBlockSelect = ({ element }) => {
        // Stop animation and show block when select in Text Adverts section on mobile
        if (this.mobileSliderFlexslider) {
            var index = Array.prototype.indexOf.call(element.parentElement.children, event.target);
            this.mobileSliderFlexslider.flexAnimate(index, true);
        }
    }

    onBlockDeselect = () => {
        // Resume animation when block is deselected in Text Adverts section on mobile
        if (this.mobileSliderFlexslider) {
            this.mobileSliderFlexslider.play();
        }
    }

    onWindowResizeBreakpoint = ({ breakpoint, oldBreakpoint }) => {
        const newIsMobile = breakpoint.order <= this.MOBILE_BREAKPOINT.order;
        const oldWasMobile = oldBreakpoint.order <= this.MOBILE_BREAKPOINT.order;
        if (newIsMobile !== oldWasMobile) {
            // Switched between mobile and desktop
            if (newIsMobile && !this.mobileSliderFlexslider) {
                // Switched from desktop to mobile and mobile slider is not loaded
                this.loadMobileSlider();
            }
        }
    }

    loadMobileSlider = () => {
        this.$mobileSlider.find('.slides li').css('width', this.element.clientWidth);

        this.mobileSliderFlexslider = this.$mobileSlider.flexslider({
            controlNav: false,
            directionNav: false,
            animation: 'slide',
        }).data('flexslider');
    }
}
